import React from "react";
import { useI18n } from "@/lib/i18n";
import { JarvisOrb } from "@/components/JarvisOrb";

export default function Login() {
  const { t } = useI18n();
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="min-h-screen hud-bg hud-grid flex items-center justify-center p-6 relative">
      <div className="relative z-10 w-full max-w-5xl grid lg:grid-cols-2 gap-10 items-center">
        <div className="flex justify-center">
          <JarvisOrb state="idle" size={300} />
        </div>
        <div className="panel corner-bracket p-10">
          <div className="label-eyebrow mb-2">MODIHOME LTD · HOME RENOVATION</div>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white glow-text">JARVIS</h1>
          <p className="text-lg text-cyan-300/80 mt-1">{t("appSub")}</p>
          <p className="text-sm text-[color:var(--txt-2)] mt-5 leading-relaxed">{t("loginDesc")}</p>
          <button onClick={handleLogin} data-testid="google-login-btn"
            className="mt-8 w-full flex items-center justify-center gap-3 bg-white text-[#0C1222] font-medium rounded-xl py-3.5 hover:bg-cyan-50 transition-colors">
            <svg width="20" height="20" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.76c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.09a6.6 6.6 0 0 1 0-4.18V7.07H2.18a11 11 0 0 0 0 9.86l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
            {t("login")}
          </button>
          <p className="text-xs text-white/40 mt-4">Google hesabınızla güvenli giriş. Verileriniz hesabınıza özeldir.</p>
        </div>
      </div>
    </div>
  );
}
